<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Hushed" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
	.stHushed1{fill:#302C3B;}
	.stHushed2{fill:#FDCA47;enable-background:new    ;}
</style>
<path class="stHushed1" d="M192,160c-4.4,0-8.8,0.3-13.9,0.9c-20.3,2.8-39.7,12.3-55.2,26.8c-6.4,6-16.6,5.7-22.6-0.8
	c-6-6.4-5.7-16.6,0.8-22.6c20-18.7,45.5-31.4,73.7-35.2c5.6-0.7,11.4-1.1,17.2-1.1c8.8,0,16,7.2,16,16S200.8,160,192,160z
	 M144.4,256c0-17.7,14.3-32,32-32c17.6,0,32,14.3,32,32c0,17.7-14.4,32-32,32C158.7,288,144.4,273.7,144.4,256z M304.4,256
	c0-17.7,14.3-32,32-32c17.6,0,32,14.3,32,32c0,17.7-14.4,32-32,32C318.7,288,304.4,273.7,304.4,256z M333,160.9
	c-4.2-0.6-8.6-0.9-13-0.9c-8.8,0-16-7.2-16-16s7.2-16,16-16c5.8,0,11.6,0.4,17.2,1.1c28.2,3.8,53.7,16.5,73.7,35.2
	c6.5,6,6.8,16.2,0.8,22.6c-6,6.5-16.2,6.8-22.6,0.8C373.6,173.2,354.2,163.7,333,160.9z"/>
<path class="stHushed2" d="M0,256C0,114.6,114.6,0,256,0s256,114.6,256,256S397.4,512,256,512S0,397.4,0,256z M176.4,288
	c17.6,0,32-14.3,32-32c0-17.7-14.4-32-32-32c-17.7,0-32,14.3-32,32C144.4,273.7,158.7,288,176.4,288z M336.4,224
	c-17.7,0-32,14.3-32,32c0,17.7,14.3,32,32,32c17.6,0,32-14.3,32-32C368.4,238.3,354,224,336.4,224z M178.1,160.9
	c5.1-0.6,9.5-0.9,13.9-0.9c8.8,0,16-7.2,16-16s-7.2-16-16-16c-5.8,0-11.6,0.4-17.2,1.1c-28.2,3.8-53.7,16.5-73.7,35.2
	c-6.5,6-6.8,16.2-0.8,22.6c6,6.5,16.2,6.8,22.6,0.8C138.4,173.2,157.8,163.7,178.1,160.9z M320,160c4.4,0,8.8,0.3,13,0.9
	c21.2,2.8,40.6,12.3,56.1,26.8c6.4,6,16.6,5.7,22.6-0.8c6-6.4,5.7-16.6-0.8-22.6c-20-18.7-45.5-31.4-73.7-35.2
	c-5.6-0.7-11.4-1.1-17.2-1.1c-8.8,0-16,7.2-16,16S311.2,160,320,160z M256,432c26.5,0,48-21.5,48-48s-21.5-48-48-48s-48,21.5-48,48
	S229.5,432,256,432z"/>
<circle class="stHushed1" cx="256.2" cy="384.2" r="48.2"/>
</svg>
